import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Problem } from "./components/Problem";
import { Solution } from "./components/Solution";
import { Method } from "./components/Method";
import { About } from "./components/About";
import { Program } from "./components/Program";
import { Pricing } from "./components/Pricing";
import { Services } from "./components/Services";
import { Testimonials } from "./components/Testimonials";
import { Bonus } from "./components/Bonus";
import { MiniProduct } from "./components/MiniProduct";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import { AGB } from "./components/AGB";
import { Widerruf } from "./components/Widerruf";
import { Impressum } from "./components/Impressum";
import { Datenschutz } from "./components/Datenschutz";
import { AdminPDFRequests } from "./components/AdminPDFRequests";
import { AdminDashboard } from "./components/AdminDashboard";

const ScrollToHashElement = () => {
  const location = useLocation();

  React.useEffect(() => {
    const scrollToElement = () => {
      if (location.hash) {
        const elementId = location.hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          // Use scrollIntoView with a slight offset
          const yOffset = -80; // Account for fixed header if any
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          return true;
        }
      }
      return false;
    };

    // Try immediately
    if (!scrollToElement()) {
      // If element not found, try again after DOM has rendered
      const timer = setTimeout(() => {
        scrollToElement();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return null;
};

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <Problem />
      <Solution />
      <Method />
      <About />
      <Program />
      <Pricing />
      <Services />
      <Testimonials />
      <Bonus />
      <MiniProduct />
      <FAQ />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHashElement />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/widerruf" element={<Widerruf />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/admin/pdf-requests" element={<AdminPDFRequests />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
